export default "__VITE_ASSET__BD__5qzJ__"